import {shuffleArray, texture} from "p3";
import common from "../../../common";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import EnemySimonSays from "../../actor/enemy/EnemySimonSays";
import QuestMinigame from "../QuestMinigame";

export default class MinigameSimonSays extends QuestMinigame {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._game = null;
        this._npc = null;

        this._noteMetadata = null;
        this._startingNotes = null;
        this._sequenceIncrementRate = null;

        this._notes = [];
        //this._sequences = [];
        this._currentSequence = 0;
        this._sequenceProgress = -1;
        this._correctSequence = null;
        this._submittedSequence = null;
        //this._unusedNotes = [];
        this._timer = {current:0, max:1.3};
        this._nextSongAdd = null;
        this._signalListeners = [];

        this._hudComponent = null;
        this._hudNoteHolder = null;
        this._hudNotes = [];
        this._uiIcon = null;

        this.coins = 1;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._noteMetadata = metadata.notes;
        //this._sequences = metadata.sequences;
        this._startingNotes = metadata.startingNotes;
        this._sequenceIncrementRate = metadata.sequenceIncrementRate;
        this._uiIcon = metadata.uiIcon;
        this.coins = metadata.coins;
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        if(this.isRunning)
            return;

        super.onMinigameStart(game);

        this._hudNoteHolder = new PIXI.Container();
        this._hudNoteHolder.currentX = 0;

        this._npc = game.findNPC(this.owner);
        this._game = game;

        const colours = [0x6ddbf7, 0xe6373a, 0x065913, 0xff61fc, 0x8d11f2];
        
        //console.log(this._game._enemies);

        this._notes = [];
        for(let i = 0; i < this._noteMetadata.length; i++) {
            //console.log(this._noteMetadata[i]);
            const note = this._game.findEnemy(this._noteMetadata[i]);
            this._signalListeners.push(note.signals.struck.add(this.onNoteStrike, this));
            this._notes.push(note);
            //console.log(note);
            note.setColour(colours[i]);
        }

        this._playSong(true);
    }

    onMinigameTrackerCreated() {
        
        super.onMinigameTrackerCreated();
        
        this._hudComponent = new PIXI.Container();
        this._hudComponent.y = GameScene.active.hud.minigameTracker.frame.height;
        GameScene.active.hud.minigameTracker.frame.addChild(this._hudComponent);

        const backing = new PIXI.Sprite(PIXI.Texture.WHITE);
        backing.tint = 0xe5e3c9;
        backing.width = GameScene.active.hud.minigameTracker.frame.width - 14;
        backing.x = 5;
        backing.height = 40;
        this._hudComponent.addChild(backing);
        GameScene.active.hud.minigameTracker.frame.height += backing.height + 20;

        this._hudNoteHolder.y = backing.height / 2;
        this._hudNoteHolder.areaWidth = backing.width;

        this._hudComponent.addChild(this._hudNoteHolder);

    }

    /**
     * @param {EnemySimonSays} note 
     */
    _playNoteSfx(note) {
        switch (note.uid) {
            case "simon_says_1":
                P3.audio.playSound("sfx_action_hit_note_00");
                break;
            case "simon_says_2":
                P3.audio.playSound("sfx_action_hit_note_01");
                break;
            case "simon_says_3":
                P3.audio.playSound("sfx_action_hit_note_02");
                break;
            case "simon_says_4":
                P3.audio.playSound("sfx_action_hit_note_03");
                break;
            case "simon_says_5":
                P3.audio.playSound("sfx_action_hit_note_03");
                break;
        }
    }

    /**
     * @param {EnemySimonSays} note
     */
    onNoteStrike(note) {
        this._playNoteSfx(note);

        if(this._nextSongAdd != null) {
            return;
        }

        if (note.uid == this._correctSequence[this._submittedSequence.length].uid) {
            const hudNote = this._hudNotes[this._submittedSequence.length];
            hudNote.tint = hudNote.colour;
            const tl = new gsap.timeline();
            tl.to(hudNote, 0.2, {rotation:10*PIXI.DEG_TO_RAD, ease:Sine.easeOut});
            tl.to(hudNote, 0.2, {rotation:-10*PIXI.DEG_TO_RAD, ease:Sine.easeOut});
            tl.to(hudNote, 0.6, {rotation:0, ease:Elastic.easeOut});
            
            this._submittedSequence.push(note);
            if (this._submittedSequence.length == this._correctSequence.length) {
                this._currentSequence ++;
                this.score ++;
                //this._correctSequence = null;
                this._nextSongAdd = true;
                this._timer.current = 0;
                this._sequenceProgress = 0;
                //this._playSong(true);
                setTimeout(() => {
                    P3.audio.playSound("vo_iv_accept_quest");
                }, 500)
            }
        } else {
            const hudNote = this._hudNotes[this._submittedSequence.length];
            const tl = new gsap.timeline();
            tl.to(hudNote.anchor, 0.1, {x:0.6, ease:Sine.easeOut});
            tl.to(hudNote.anchor, 0.1, {x:0.4, ease:Sine.easeOut});
            tl.to(hudNote.anchor, 0.6, {x:0.5, ease:Elastic.easeOut, onComplete:() => {
                P3.audio.playSound(["vo_iv_oh_00", "vo_iv_oh_01", "vo_iv_oh_00"])
            }});
            let val = {x:0}
            gsap.to(val, 2, {x:1, ease:Linear.easeNone, onUpdate:() => {
                hudNote.tint = Math.floor((val.x * 10)) % 2 == 0 ? 0x000000 : 0xFFFFFF;
            }});
            //this._game.onEnemyAttack(note, null, note.damage);
            this._nextSongAdd = false;
            this._timer.current = 0;
            this._sequenceProgress = 0;
            //this._playSong(false);
        }
    }

    /**
     * @param {GameScene} game
    */
    onMinigameUpdate(game) {
        super.onMinigameUpdate();

        if (this.isRunning) {
            game.toggleHostileEnemyLogic(false);

            if (this._sequenceProgress >= 0) {
                this._timer.current += window.dt;
                if (this._timer.current >= this._timer.max) {
                    if (this._nextSongAdd != null) {
                        this._playSong(this._nextSongAdd);
                        this._nextSongAdd = null;
                    }
                    else if (this._sequenceProgress >= this._correctSequence.length) {
                        this._sequenceProgress = -1;
                        this._enableUserHits();
                        for (let i in this._hudNotes) {
                            this._hudNotes[i].tint = 0xFFFFFF;
                        }
                        this._timer.current = 0;
                    }
                    else {
                        this._correctSequence[this._sequenceProgress].soundOut();
                        this._addNoteToUI(this._correctSequence[this._sequenceProgress]);
                        this._sequenceProgress++;
                        this._timer.current = 0;
                    }
                }
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);

        for (let i in this._signalListeners) {
            this._signalListeners[i].detach();
        }
        this.bestScore = this.score;
        this._enableUserHits();

        game.toggleHostileEnemyLogic(true);
    }

    onMinigameCancel(game) {
        super.onMinigameCancel(game);

        for (let i in this._signalListeners) {
            this._signalListeners[i].detach();
        }

        game.toggleHostileEnemyLogic(true);
    }

    _playSong(add = false)
    {
        this._clearUINotes();
        /*
        if(this._correctSequence == null) {
            const sequence = this._sequences[Math.min(this._currentSequence, this._sequences.length-1)];
            //console.log(sequence);
            const noteTypes = this._notes.slice();
            let i;
            for (i = 0; i <= Math.max(0, noteTypes.length - sequence.maxNotes); i++) {
                noteTypes.splice(Math.floor(Math.random() * noteTypes.length), 1);
            }
            this._correctSequence = noteTypes.slice();
            for (i = 0; i < sequence.repeatNotes; i++) {
                this._correctSequence.push(noteTypes[Math.floor(Math.random() * noteTypes.length)]);
            }
            shuffleArray(this._correctSequence);
        }*/

        
        if (add) {
            let i;
            if(this._correctSequence == null) {
                this._correctSequence = this._notes.slice();
                
                for (i = 0; i <= Math.max(0, this._correctSequence.length - this._startingNotes); i++) {
                    //this._unusedNotes.push(
                        this._correctSequence.splice(Math.floor(Math.random() * this._correctSequence.length), 1);
                    //);
                }
            } else {
                /*if (this._unusedNotes.length > 0 && Math.random() > 0.5) {
                    this._correctSequence.push(this._unusedNotes.splice(Math.floor(Math.random() * this._unusedNotes.length), 1));
                } else {*/
                for (i = 0; i <= Math.floor(this._currentSequence / this._sequenceIncrementRate); i++) {
                    this._correctSequence.push(this._notes[Math.floor(Math.random() * this._notes.length)]);
                }
                //}
            }
        }

        this._sequenceProgress = 0;
        this._disableUserHits();
        this._submittedSequence = [];
    }

    _disableUserHits() {
        for( let i in this._notes) {
            this._notes[i].allowStrike = false;
        }
    }

    _enableUserHits() {
        for( let i in this._notes) {
            this._notes[i].allowStrike = true;
        }
    }

    _addNoteToUI(note) {
        const uiNote = new PIXI.Sprite(texture(this._uiIcon));
        uiNote.scale.set((this._hudNoteHolder.y * 2) / uiNote.height);
        uiNote.anchor.set(0.5);
        uiNote.colour = uiNote.tint = note.colour;
        this._hudNotes.push(uiNote);
        uiNote.x = this._hudNoteHolder.currentX + (uiNote.width/2);
        this._hudNoteHolder.addChild(uiNote);
        this._hudNoteHolder.currentX += uiNote.width + 4;
        this._hudNoteHolder.x = (GameScene.active.hud.minigameTracker.frame.width / 2) - (this._hudNoteHolder.width / 2);
        const targetScale = uiNote.scale.x;
        uiNote.scale.set(0);
        gsap.to(uiNote.scale, 0.3, {x:targetScale, y:targetScale, ease:Back.easeOut});
    }

    _clearUINotes() {
        for(let i = this._hudNotes.length-1; i >= 0; i--) {
            this._hudNoteHolder.removeChild(this._hudNotes[i]);
            this._hudNotes.splice(i, 1);
        }
        this._hudNoteHolder.currentX = 0;
    }
}